import { styled, Box } from '@mui/material';
import { lighten, darken } from '@mui/material/styles';

export const DashboardVariantV2GiverStatusInfoWidgetCardBase = styled(Box, {
  shouldForwardProp: (prop) => prop !== 'accentColor' && prop !== 'isSelected',
})<{ accentColor: string; isSelected: boolean }>(
  ({ theme, accentColor, isSelected }) => ({
    width: '100%',
    padding: theme.spacing(1.5, 2),
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'stretch',
    gap: theme.spacing(2),
    borderRadius: 12,
    backgroundColor: theme.palette.common.white,
    justifyContent: 'flex-start',
    color: accentColor,
    border: '1px solid transparent',
    cursor: 'pointer',
    transition: theme.transitions.create(['background-color', 'border-color'], {
      duration: theme.transitions.duration.standard,
    }),

    ...(isSelected && {
      backgroundColor: lighten(accentColor, 0.8),
      borderColor: darken(accentColor, 0.4),
    }),
  }),
);
